// Dolores's payphone calls (docs/06 §4, §7; docs/05 §8). Lines are i18n `dolores.<script>.<n>`,
// in lowercase handwriting. The phone rings once the player has refused 13 Propositions.
export const PHONE_SCRIPTS = {
  first: 4,
  plug_1: 2,
  plug_2: 2,
  plug_3: 2,
  plug_4: 2,
  plug_5: 2,
  allFound: 3,
  farewell: 1,
} satisfies Record<string, number>;
export type PhoneScript = keyof typeof PHONE_SCRIPTS;

export function phoneKeys(id: PhoneScript): string[] {
  return Array.from({ length: PHONE_SCRIPTS[id] }, (_, i) => `dolores.${id}.${i + 1}`);
}
